<template>
  <div class="container mx-auto p-4">
    <h1 class="text-2xl font-bold mb-6">Manuals</h1>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      <div
        v-for="manual in manuals"
        :key="manual.id"
        @click="viewManual(manual.id)"
        class="bg-white rounded-lg shadow-md p-6 cursor-pointer hover:shadow-lg transition-shadow duration-300 border border-gray-200"
      >
        <div class="flex items-center mb-4">
          <svg class="w-8 h-8 text-orange-400 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
          </svg>
          <h3 class="text-lg font-semibold text-gray-800">{{ manual.title }}</h3>
        </div>
        <p class="text-gray-600 text-sm mb-4">{{ manual.description }}</p>
        <div class="flex items-center text-sm text-gray-500">
          <svg class="w-4 h-4 mr-1" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z"></path>
          </svg>
          {{ formatDate(manual.created_at) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/services/api';

export default {
  name: "ManualsPage",
  data() {
    return {
      manuals: [],
    };
  },
  mounted() {
    this.fetchManuals();
  },
  methods: {
    async fetchManuals() {
      try {
        const response = await api.getManuals();
        this.manuals = response.data || response;
      } catch (error) {
        console.error('Error fetching manuals:', error);
        // Fallback to mock data if API fails
        this.manuals = [
          {
            id: 1,
            title: "Blood Bank Operations Manual",
            description: "Comprehensive guide for blood bank operations and procedures",
            file_url: "https://example.com/manual1.pptx",
            created_at: "2024-01-15T10:00:00Z"
          },
          {
            id: 2,
            title: "Donor Management Guidelines",
            description: "Best practices for donor recruitment and management",
            file_url: "https://example.com/manual2.pptx",
            created_at: "2024-02-20T14:30:00Z"
          },
          {
            id: 3,
            title: "Quality Control Procedures",
            description: "Quality assurance and control procedures for blood products",
            file_url: "https://example.com/manual3.pptx",
            created_at: "2024-03-10T09:15:00Z"
          }
        ];
      }
    },
    viewManual(manualId) {
      this.$router.push({ name: 'ManualViewer', params: { id: manualId } });
    },
    formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      });
    }
  }
};
</script>

<style scoped>
/* Additional styles if needed */
</style>